export function generateAgoraUID() {
    //Token generator expects a 6 digit int
    const min = Math.ceil(100000)
    const max = Math.floor(999999)
    const uid = Math.floor(Math.random() * (max - min) + min)
    return uid
}
